/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleMerchantMarketReportRowData } from './GoogleMerchantMarketReportRowData';
import {
    GoogleMerchantMarketReportRowDataFromJSON,
    GoogleMerchantMarketReportRowDataFromJSONTyped,
    GoogleMerchantMarketReportRowDataToJSON,
    GoogleMerchantMarketReportRowDataToJSONTyped,
} from './GoogleMerchantMarketReportRowData';

/**
 * 
 * @export
 * @interface GoogleMerchantMarketReportData
 */
export interface GoogleMerchantMarketReportData {
    /**
     * 
     * @type {Array<string>}
     * @memberof GoogleMerchantMarketReportData
     */
    availableRecipes?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof GoogleMerchantMarketReportData
     */
    publishedAtByRecipe?: object;
    /**
     * 
     * @type {Array<GoogleMerchantMarketReportRowData>}
     * @memberof GoogleMerchantMarketReportData
     */
    rows?: Array<GoogleMerchantMarketReportRowData>;
}

/**
 * Check if a given object implements the GoogleMerchantMarketReportData interface.
 */
export function instanceOfGoogleMerchantMarketReportData(value: object): value is GoogleMerchantMarketReportData {
    return true;
}

export function GoogleMerchantMarketReportDataFromJSON(json: any): GoogleMerchantMarketReportData {
    return GoogleMerchantMarketReportDataFromJSONTyped(json, false);
}

export function GoogleMerchantMarketReportDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleMerchantMarketReportData {
    if (json == null) {
        return json;
    }
    return {
        
        'availableRecipes': json['availableRecipes'] == null ? undefined : json['availableRecipes'],
        'publishedAtByRecipe': json['publishedAtByRecipe'] == null ? undefined : json['publishedAtByRecipe'],
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(GoogleMerchantMarketReportRowDataFromJSON)),
    };
}

export function GoogleMerchantMarketReportDataToJSON(json: any): GoogleMerchantMarketReportData {
    return GoogleMerchantMarketReportDataToJSONTyped(json, false);
}

export function GoogleMerchantMarketReportDataToJSONTyped(value?: GoogleMerchantMarketReportData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'availableRecipes': value['availableRecipes'],
        'publishedAtByRecipe': value['publishedAtByRecipe'],
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(GoogleMerchantMarketReportRowDataToJSON)),
    };
}

